import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import find from 'lodash/find';
import has from 'lodash/has';

export const findImageInfo = (images, id) => {
    const userImages = find(images, i => has(i, id));
    if (!isEmpty(userImages)) {
        return userImages[id];
    }
    return null;
};

export const imageContextSelector = (state, id) => {
    const {images, users, editHistory} = state;
    const imageInfo = findImageInfo(images, id);
    const userId = isNil(imageInfo) ? null : imageInfo.userId;
    const userImages = (!isNil(userId) && !isEmpty(images)) ? images[userId] : null;
    const user = (!isNil(userId) && !isEmpty(users)) ? users[userId] : null;
    const imageEditHistory = (!isNil(id) && !isEmpty(editHistory)) ? editHistory[id] : {};
    return {id, images, userId, imageInfo, userImages, user, imageEditHistory};
};



// WEBPACK FOOTER //
// ./src/reducers/imageContextSelector.js